import { render, staticRenderFns } from "./share.vue?vue&type=template&id=43730286"
import script from "./share.vue?vue&type=script&lang=ts"
export * from "./share.vue?vue&type=script&lang=ts"
import style0 from "./share.vue?vue&type=style&index=0&id=43730286&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports